<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="accountUsersSelected"
    multiple
    deletable-chips
    small-chips
    :clearable="!unclearable"
    :items="accountUsersItems"
    :loading="accountUsersLoading"
    :search-input.sync="accountUsersSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import AccountUsers from "@/api/account_users";

export default {
  name: "SearcherAccountUser",

  props: {
    value: Array,
    type: Array,
    noLabel: Boolean,
    label: String,
    createrName: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    accountUsersItems() {
      return this.accountUsers.map((user) => {
        const Description = user.name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == user.id
            )
          : false;
        return Object.assign({}, user, { Description, disabled });
      });
    },
  },

  data: () => ({
    accountUsers: [],
    accountUsersLoading: false,
    accountUsersSearch: "",
    accountUsersSelected: null,
  }),

  mounted() {
    this.getAccountUsersFromAPI();
  },

  methods: {
    getAccountUsersFromAPI() {
      this.accountUsersLoading = true;
      AccountUsers.fetchAll({
        type: this.type,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.accountUsers = response.data.account_users;
            }
            this.accountUsersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.accountUsersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.accountUsersSelected = this.value;
      },
    },
    accountUsersSelected: {
      handler() {
        this.$emit("input", this.accountUsersSelected);
      },
    },
    type: {
      handler() {
        // this.getAccountUsersFromAPI();
      },
    },
  },
};
</script>
